var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCloudV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0336 17.1872C0.00234791 17.9684 0.783598 9.37468 7.0336 10.1559C4.68985 1.56218 17.9711 1.56218 17.1898 7.81218C25.0023 5.46843 25.0023 17.9684 17.9711 17.1872",
    stroke: "#1744E2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4082 19.5313L12.502 22.6562M12.502 22.6562L8.5957 19.5312M12.502 22.6562L12.502 10.9375",
    stroke: "#1744E2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCloudV2);
export default __webpack_public_path__ + "static/media/downloadCloud_v2.4f9e2b8b9706c7795ef4134e3b4aea8f.svg";
export { ForwardRef as ReactComponent };